import { analytics } from 'analytics'
import { useEffect, useState } from 'react'

export const useBranch = () => {
  useEffect(() => {
    if (!window.branch) return

    const handleCTAClick = () => {
      analytics.events.appDownload()
    }

    window.branch.addListener('didClickJourneyCTA', handleCTAClick)
    return () => {
      window.branch.removeListener('didClickJourneyCTA', handleCTAClick)
    }
  }, [])
}

export const useBranchView = () => {
  const [inView, setInView] = useState(false)

  useEffect(() => {
    if (!window.branch) return

    const handleDidShow = () => setInView(true)
    const handleDidClose = () => setInView(false)

    window.branch.addListener('didShowJourney', handleDidShow)
    window.branch.addListener('didCloseJourney', handleDidClose)

    return () => {
      window.branch.removeListener('didShowJourney', handleDidShow)
      window.branch.removeListener('didCloseJourney', handleDidClose)
    }
  }, [inView])

  return inView
}
